import z from "zod";

export const diagnosticObjectivePieceSchema = z.object({
  description: z.string().optional(),
  unit_price: z.string({ message: 'Campo obrigatório' }),
  quantity: z.string({ message: 'Campo obrigatório' }),
  warranty_in_days: z.string({ message: 'Campo obrigatório' }),
});

export type DiagnosticObjectivePieceValidationSchema = z.infer<typeof diagnosticObjectivePieceSchema>;
